const APP_ID = 731;
const GN_APP_ID = 875;
const APP_IDS = {
    AUTODEBIT: 731,
    LAZADA: 748,
    GOOGLE: 579,
    GN: 875
};
const APP_NAME = "Thanh toán tự động";
const APP_NAME_SETTING = "Xác thực liên kết";

const LIST_BILLING_APPIDS = [17, 18, 20, 21];

const TIME_DATA = [
    { "value": 1, "label": "1 tháng" },
    { "value": 2, "label": "2 tháng" },
    { "value": 3, "label": "3 tháng" },
    { "value": 6, "label": "6 tháng" },
    { "value": 12, "label": "12 tháng" },
    { "value": 0, "label": "Vô thời hạn" },
];

var TIME_DATA_MAP = TIME_DATA.reduce(function (map, obj) {
    map[obj.value] = obj.label;
    return map;
}, {});

const LIMIT_DATA = [
    { "value": 500000, "label": "500.000đ" },
    { "value": 1000000, "label": "1.000.000đ" },
    { "value": 5000000, "label": "5.000.000đ" },
    { "value": 10000000, "label": "10.000.000đ" },
    { "value": 20000000, "label": "20.000.000đ" },
    { "value": 50000000, "label": "50.000.000đ" },
    { "value": 0, "label": "Hạn mức khả dụng" },
];

var LIMIT_DATA_MAP = LIMIT_DATA.reduce(function (map, obj) {
    map[obj.value] = obj.label;
    return map;
}, {});

const BINDING_STATUS = {
    CONFIRMED: 1,
    CANCELED: 3,
    DISABLE: 4
}
const NO_PARAM_REDIRECT_APPID = [2638]
const TIKTOK_WHITELIST = ['AQEAAG4Ii9PMYxEqbtPvVyQjxkvwK','AgEAaAHRrbeIis5uXq56sKvN4AYA','AQEAAHZINKyq99E9S8jM99WaXFHiy8K','AgEAaATc4kMYiy9SU7VG9P4chrcEcA','AQEAAAXFj3v8zkFWmY02CVGMAVkK','AQEAAGxgRl2IFULVkTxankBNtlEK']
const BINDING_CREATED = 'CREATED';
const BINDING_CONFIRMED = 'CONFIRMED';
const BINDING_ACTIVE = 'ACTIVE';
const BINDING_EXPIRED = 'EXPIRED';
const BINDING_FAILED = 'FAILED';
export {
    APP_IDS,
    APP_ID,
    GN_APP_ID,
    APP_NAME,
    APP_NAME_SETTING,
    TIME_DATA,
    LIMIT_DATA,
    TIME_DATA_MAP,
    LIMIT_DATA_MAP,
    BINDING_STATUS,
    LIST_BILLING_APPIDS,
    NO_PARAM_REDIRECT_APPID,
    TIKTOK_WHITELIST,
    BINDING_CREATED,
    BINDING_ACTIVE,
    BINDING_EXPIRED,
    BINDING_CONFIRMED,
    BINDING_FAILED
};
